// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1MASa","title":"Header_title__2_aUg","left":"Header_left__3wfD0","clinicName":"Header_clinicName__1xVq7"};